import { abbr } from "@/lib/api";

const NORTH_POS = [[200, 105], [100, 50], [50, 105], [100, 200], [50, 300], [100, 355], [200, 300], [300, 355], [350, 300], [300, 200], [350, 105], [300, 50]];
const SOUTH_POS = [[0, 1], [0, 2], [0, 3], [1, 3], [2, 3], [3, 3], [3, 2], [3, 1], [3, 0], [2, 0], [1, 0], [0, 0]];

const byHouse = (planets) => {
  const m = {};
  (planets || []).forEach((p) => { (m[p.house] = m[p.house] || []).push(p); });
  return m;
};

const label = (t, p) => `${abbr(t.names.planets[p.key])}${p.retro && p.key !== "rahu" && p.key !== "ketu" ? "*" : ""}`;

export const NorthChart = ({ t, data }) => {
  const houses = byHouse(data?.planets);
  const lagna = data?.lagna?.sign ?? 0;
  return (
    <svg viewBox="0 0 400 400" className="w-full max-w-[440px] mx-auto" data-testid="north-chart">
      <rect x="2" y="2" width="396" height="396" fill="#fffdf9" stroke="var(--saffron)" strokeWidth="1.5" />
      <path d="M2 2L398 398M398 2L2 398M200 2L398 200L200 398L2 200Z" fill="none" stroke="var(--saffron)" strokeWidth="1.2" />
      {NORTH_POS.map(([x, y], i) => {
        const ps = houses[i + 1] || [];
        return (
          <g key={i}>
            <text x={x} y={y - 18} textAnchor="middle" fontSize="11" fill="var(--muted)">{((lagna + i) % 12) + 1}</text>
            {i === 0 && <text x={x} y={y - 34} textAnchor="middle" fontSize="10" fill="var(--saffron)">{abbr(t.kundali.lagna, 3)}</text>}
            {ps.map((p, j) => (
              <text key={p.key} x={x + ((j % 2) * 2 - 1) * (ps.length > 1 ? 16 : 0)} y={y + Math.floor(j / 2) * 15} textAnchor="middle" fontSize="12.5" fontWeight="600" fill="var(--ink)">{label(t, p)}</text>
            ))}
          </g>
        );
      })}
    </svg>
  );
};

export const SouthChart = ({ t, data, signs }) => {
  const bySign = {};
  (data?.planets || []).forEach((p) => { (bySign[p.sign] = bySign[p.sign] || []).push(p); });
  return (
    <div className="grid grid-cols-4 grid-rows-4 aspect-square w-full max-w-[440px] mx-auto border border-[color:var(--saffron)] bg-[#fffdf9]" data-testid="south-chart">
      {SOUTH_POS.map(([r, c], s) => (
        <div key={s} style={{ gridRow: r + 1, gridColumn: c + 1 }} className="border border-[color:var(--saffron)]/50 p-1.5 text-[11px] sm:text-xs leading-tight">
          <div className={`text-[10px] ${data?.lagna?.sign === s ? "text-[color:var(--saffron)] font-semibold" : "text-[color:var(--muted)]"}`}>
            {abbr(signs[s], 3)}{data?.lagna?.sign === s ? ` · ${abbr(t.kundali.lagna, 3)}` : ""}
          </div>
          <div className="mt-1 flex flex-wrap gap-x-1.5 font-semibold">{(bySign[s] || []).map((p) => <span key={p.key}>{label(t, p)}</span>)}</div>
        </div>
      ))}
      <div style={{ gridRow: "2 / 4", gridColumn: "2 / 4" }} className="flex items-center justify-center display text-xl text-[color:var(--gold)]">{t.kundali.lagna}</div>
    </div>
  );
};
